import { z } from "zod";
import { cbHttp } from "./http.service";
import { PaymentPackagesSchema } from "@/schemas/paymentPackages.schema";

export const getPaymentPackages = async (): Promise<z.infer<typeof PaymentPackagesSchema>[]> => {
    return cbHttp.get(`/api/paymentpackages/paymentpackages`);
}